import { createSlice } from "@reduxjs/toolkit";
const name = "schedules";

const schedulesSlice = createSlice({
  name,
  initialState: {
    schedules: [],
    filteredSchedules: [],
    isSchedulesLoading: false,
    isFilteredSchedulesLoading: false,
    selectedToggleBoxValue: "Name",
    sortByValue: "Id",
    searchInputValue: "",
    searchParams: null,
    error: null,

    isCreateRequestLoading: false,
    isUpdateRequestLoading: false,
    isRemoveRequestLoading: false,
  },
  reducers: {
    updateSearchParams: (state, action) => {
      const { selectedToggleBox, searchInput, sortBy } = action.payload;
      state.selectedToggleBoxValue = selectedToggleBox;
      state.searchInputValue = searchInput;
      state.sortByValue = sortBy;
    },

    getSchedules: (state) => {
      state.isSchedulesLoading = true;
    },
    getSchedulesSuccess: (state, action) => {
      state.isSchedulesLoading = false;
      state.schedules = action.payload;
    },
    getSchedulesFailure: (state, action) => {
      state.isSchedulesLoading = false;
      state.error = action.payload;
    },

    getFilteredSchedules: (state, action) => {
      state.isFilteredSchedulesLoading = true;
      state.searchParams = action.payload;
    },
    getFilteredSchedulesSuccess: (state, action) => {
      state.isFilteredSchedulesLoading = false;
      state.filteredSchedules = action.payload;
    },
    getFilteredSchedulesFailure: (state, action) => {
      state.isFilteredSchedulesLoading = false;
      state.error = action.payload;
    },

    createSchedule: (state, action) => {
      state.isCreateRequestLoading = true;
    },
    createScheduleSuccess: (state) => {
      state.isCreateRequestLoading = false;
    },
    createScheduleFailure: (state, action) => {
      state.isCreateRequestLoading = false;
      state.error = action.payload;
    },

    updateSchedule: (state, action) => {
      state.isCreateRequestLoading = true;
    },
    updateScheduleSuccess: (state) => {
      state.isCreateRequestLoading = false;
    },
    updateScheduleFailure: (state, action) => {
      state.isCreateRequestLoading = false;
      state.error = action.payload;
    },

    removeSchedule: (state, action) => {
      state.isRemoveRequestLoading = true;
    },
    removeScheduleFailure: (state) => {
      state.isRemoveRequestLoading = false;
    },
    removeScheduleSuccess: (state, action) => {
      state.isRemoveRequestLoading = false;
      state.error = action.payload;
    },
  },
});

export const {
  updateSearchParams,

  getSchedules,
  getSchedulesFailure,
  getSchedulesSuccess,

  getFilteredSchedules,
  getFilteredSchedulesSuccess,
  getFilteredSchedulesFailure,

  createSchedule,
  createScheduleSuccess,
  createScheduleFailure,

  updateSchedule,
  updateScheduleSuccess,
  updateScheduleFailure,

  removeSchedule,
  removeScheduleFailure,
  removeScheduleSuccess,
} = schedulesSlice.actions;

export default schedulesSlice.reducer;
